<template>
  <fragment>
    <button
      ref="filterButton"
      class="btn top-block__filter"
      @click="showFilter"
    >
      <i class="material-icons">filter_list</i>
      Фильтр
    </button>
    <transition name="fade">
      <form
        v-show="isFilterShown"
        ref="filterForm"
        class="top-block__filter__block"
        @submit.prevent="applyFilters"
      >
        <div class="top-block__filter__block__wrapper">
          <div
            class="top-block__filter__block__wrapper__close"
            @click="hideFilter"
          >
            <button
              type="button"
              class="close"
            >
              <i class="material-icons">close</i>
            </button>
          </div>
          <div class="row">
            <div class="col">
              <template v-if="eventList">
                <b class="d-flex pl-2 mb-3">Поиск по полям</b>
                <div class="top-block__filter__block__deep mb-2">
                  <label for="event">Событие</label>
                  <div class="input-group">
                    <multiselect
                      v-model="filters.event"
                      :options="eventList"
                      placeholder="Выберите событие"
                      selected-label=""
                      select-label=""
                      deselect-label="Убрать"
                    >
                      <template slot="noResult">
                        По данному запросу ничего не найдено
                      </template>
                      <template slot="noOptions">
                        Нет доступных ролей
                      </template>
                    </multiselect>
                    <!-- <input
                    id="event"
                    v-model.trim="filters.event"
                    class="form-control form-control-sm"
                    placeholder="Событие"
                  > -->
                  </div>
                </div>
              </template>
              <b class="d-flex pl-2 mb-3">Поиск по дате</b>
              <div class="top-block__filter__block__deep mb-2">
                <label>
                  DateFrom
                </label>
                <div class="input-group">
                  <flat-pickr
                    v-model="dateFrom"
                    class="form-control form-control-sm datepicker"
                    type="Timestamp"
                    :config="dateFromConfig"
                  />
                </div>
              </div>
              <div class="top-block__filter__block__deep mb-2">
                <label>
                  DateTo
                </label>
                <div class="input-group">
                  <flat-pickr
                    v-model="dateTo"
                    class="form-control form-control-sm datepicker"
                    type="Timestamp"
                    :config="dateToConfig"
                  />
                </div>
              </div>
            </div>
          </div>
          <div class="top-block__filter__block__deep footer">
            <button
              class="btn btn-secondary-ford-gray"
              type="button"
              @click="resetFilters"
            >
              Сбросить
            </button>
            <button
              class="btn btn-primary-ford-orange"
              type="submit"
            >
              <i class="material-icons">check</i>
              Применить
            </button>
          </div>
        </div>
      </form>
    </transition>
  </fragment>
</template>

<script>
import { Russian } from 'flatpickr/dist/l10n/ru.js';

export default {
  name: 'FilterEmails',
  data: () => ({
    isFilterShown: false,
    filters: {
      event: null,
    },
    dateFrom: null,
    dateTo: null,
    dateFromConfig: {
      locale: Russian,
      dateFormat: 'Z',
      altInput: true,
      altFormat: 'd.m.Y, H:i',
      enableTime: true,
    },
    dateToConfig: {
      locale: Russian,
      dateFormat: 'Z',
      altInput: true,
      altFormat: 'd.m.Y, H:i',
      enableTime: true,
    },
    eventList: null,
  }),
  computed: {
    filterKeys() {
      return Array.from(Object.keys(this.filters));
    },
    filtersComputed() {
      return {
        'timestamp[gte]': this.dateFrom,
        'timestamp[lte]': this.dateTo,
        ...this.filters,
      };
    },
  },
  created() {
    this.getDefaultDates();
    this.getEventList();
  },
  methods: {
    showFilter() {
      this.isFilterShown = true;
      setTimeout(() => {
        document.addEventListener('click', this.handleOutsideClick);
      }, 0);
    },
    hideFilter() {
      this.isFilterShown = false;
      setTimeout(() => {
        document.removeEventListener('click', this.handleOutsideClick);
      }, 0);
    },
    resetFilters() {
      this.getDefaultDates();
      this.$set(this.filters, 'event', null);
      this.$emit('applyFilters', this.filtersComputed);
    },
    applyFilters() {
      this.$emit('applyFilters', this.filtersComputed);
      this.hideFilter();
    },
    handleOutsideClick(evt) {
      const { filterForm, filterButton } = this.$refs; //eslint-disable-line

      if (filterForm && filterForm.contains(evt.target)) {
        return;
      }

      const calendars = document.querySelectorAll('.flatpickr-calendar');
      for (let i = 0; i < calendars.length; i++) {
        if (calendars[i].contains(evt.target)) {
          return;
        }
      }

      if (filterButton && filterButton.contains(evt.target) && !this.isFilterShown) {
        return;
      }

      this.hideFilter();
    },
    getDefaultDates() {
      this.dateFrom = this.$moment()
        .subtract(7, 'day')
        .toISOString();
      this.dateTo = this.$moment().toISOString();
    },
    async getEventList() {
      const { items } = await this.$http.get('mailer/1.0/events');
      this.eventList = items.map(it => it.name);
    },
  },
};
</script>
